module.exports = __webpack_public_path__ + "img/p3_4.a22d2541.png";